<script>
	// Custom line mark for the Legends of Tasmania experience grid. Drawn to the
	// same geometry as the lucide set used elsewhere (24px box, 1.5 stroke,
	// round caps) so it sits naturally beside them.
	let { class: className = '' } = $props();
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 24"
	fill="none"
	stroke="currentColor"
	stroke-width="1.5"
	stroke-linecap="round"
	stroke-linejoin="round"
	class={className}
	aria-hidden="true"
>
	<path d="M6 10.5h12v4a6 6 0 0 1-12 0Z" />
	<path d="M7.5 10.5a4.5 3.2 0 0 1 9 0" />
	<path d="M12 7.3V5.4" />
	<path d="M17.4 17h2.1v1.9" />
</svg>
